import { tw } from '@twind/core';
import { DidomiHintbox } from '@didomi/ui-atoms-react';
import { ROLE_PERMISSION_DESCRIPTIONS } from '../constants';
import type { ValidatedOAuthContext } from '../types';

export function PermissionsDisplay({ ctx }: { ctx: ValidatedOAuthContext }) {
  const permissions = ROLE_PERMISSION_DESCRIPTIONS[ctx.role_id];

  return (
    <DidomiHintbox titleText="This configuration has access to:" headerIconName="edit" className={tw('mb-3')}>
      <ul className={tw('m-0 flex list-none flex-col gap-2xs p-0')}>
        {permissions.map((permission, index) => (
          <li key={index} className={tw('body-small flex items-start text-neutral-gray-7')}>
            <span className={tw('mr-xs')}>•</span>
            <span>{permission}</span>
          </li>
        ))}
      </ul>
    </DidomiHintbox>
  );
}
